export const IMAGE_OBJECT_REMAP = { uRL: 'url', URL: 'url' }
